import type { Command } from '@invaders/game';

export interface Transport {
  send(cmd: Command): void;
  onCommand(handler: (cmd: Command) => void): void;
}

/** Same-machine transport; a WebSocketTransport will implement the same interface at step 6. */
export class LocalTransport implements Transport {
  private readonly handlers: ((cmd: Command) => void)[] = [];

  send(cmd: Command): void {
    for (const handler of this.handlers) handler(cmd);
  }

  onCommand(handler: (cmd: Command) => void): void {
    this.handlers.push(handler);
  }
}
